import { CustomToggleButton } from './components'
import { CustomToggleButtonProps } from './types'

export function ToggleButton(props: JSX.IntrinsicAttributes & CustomToggleButtonProps) {
  return <CustomToggleButton {...props}>{props.children}</CustomToggleButton>
}
